'use client';
import "./globals.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'hover.css/css/hover.css'; 
import { useEffect, useState } from 'react';
import Loader from './components/Loader';
import { Space_Grotesk } from "next/font/google"; 
import AIStickyBar from '@/app/components/AIStickyBar';
const spaceGrotesk = Space_Grotesk({
  subsets: ["latin"],
  weight: ["300", "400", "500", "600", "700"],
  variable: "--font-space-grotesk",
});

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleComplete = () => setLoading(false);

    if (document.readyState === 'complete') {
      handleComplete();
    } else {
      window.addEventListener('load', handleComplete);
    }

    return () => window.removeEventListener('load', handleComplete);
  }, []);

  useEffect(() => {
    /* ----------------------------------
       ✅ Voiceflow Chat Widget
    ---------------------------------- */
    // const vfScript = document.createElement('script');
    // vfScript.src = 'https://cdn.voiceflow.com/widget/bundle.mjs';
    // vfScript.type = 'text/javascript';
    // vfScript.async = true;

    // vfScript.onload = () => {
    //   if (window.voiceflow?.chat) {
    //     window.voiceflow.chat.load({
    //       verify: { projectID: '66ba85a2cf5adb4c27b4fc0e' },
    //       url: 'https://general-runtime.voiceflow.com',
    //       versionID: 'production',
    //     });

    //     // ⭐ EASIEST WAY: Make global function to open chat
    //     window.openVFChat = () => window.voiceflow.chat.open();
    //   }
    // };

    // document.body.appendChild(vfScript);

    /* ----------------------------------
       ✅ Google Analytics
    ---------------------------------- */
    const gaScript = document.createElement('script');
    gaScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-RJLHRFWD5T';
    gaScript.async = true;
    document.head.appendChild(gaScript);

    const inlineGAScript = document.createElement('script');
    inlineGAScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){ dataLayer.push(arguments); }
      gtag('js', new Date());
      gtag('config', 'G-RJLHRFWD5T');
    `;
    document.head.appendChild(inlineGAScript);

  }, []);

  return (
    <html lang="en">
      <body className={spaceGrotesk.className}>
        {loading && <Loader loading={loading}/>}
        {!loading && children}
        <AIStickyBar />
      </body>
    </html>
  );
}
